var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:_vm.classList})
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Sidebar/SidebarNavDivider.vue?vue&type=template&id=6679d20d&
// module id = null
// module chunks = 